<template>
  <div class="lp-pixel-treeview">
    <label class="campaign-details__treeview-header">
      {{ t('Landing where LP Pixel will be installed') }}
    </label>
    <ui-treeview
      v-if="flowMap && flowMap.length"
      class="campaign-details__treeview"
      :items="flowMap"
    >
      <template #default="{ item }">
        <div
          style="width: 100%; display: flex;"
          class="condition"
          :style="{
            width: isTreeNodeLanding(item) ? 'calc(100% - 76px)' : '100%',
          }"
        >
          <div v-if="item.name" style="display: inline-block">
            <span
              @click="handleSelectLanding(item)"
              :class="{
                'lp-pixel-treeview__treeview-link': isTreeNodeLanding(item),
                'lp-pixel-treeview__treeview-link--active': isTreeNodeLandingActive(item),
              }"
            >{{ item.name }}</span>
          </div>
          <template v-else-if="item.conditions">
            <span
              class="condition__rule"
              :class="{
                'condition__rule--opposite-rule': isOppositeFlowRulePredicate(contition.predicate),
              }"
              v-for="(contition, index) in item.conditions"
              :key="index"
            >{{ contition.name }}</span>
          </template>
          <span v-else>Empty</span>
        </div>
      </template>
    </ui-treeview>
  </div>
</template>

<script setup lang="ts">
import { useLpPixelTreeview } from './useLpPixelTreeview';

const props = defineProps<{
  flow: Record<string, unknown>;
}>();

const selectedLanding = defineModel<TreeViewItem | null>('selectedLanding', { default: null });

const {
  t,
  flowMap,
  isOppositeFlowRulePredicate,
  isTreeNodeLanding,
  isTreeNodeLandingActive,
  handleSelectLanding,
} = useLpPixelTreeview(() => props.flow, selectedLanding);
</script>

<style lang="scss">
.lp-pixel-treeview {
  &__treeview-link {
    color: var(--color-blue);
    cursor:pointer;

    &:hover {
      text-decoration: underline;
    }

    &--active {
      font-weight: 700;
    }
  }
}
</style>
